const routes = [
    {
        path: "/projected-enrollments",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "projectedenrollment_index"
        }
    }
];

export default routes;
